import axios from "axios";

export const axiosWithRails = axios.create();

// NOTE: MOCK_SERVER_BASE_URLはstorybookから起動した際に、mockへの差し替え目的で設定される
declare const MOCK_SERVER_BASE_URL;
axiosWithRails.defaults.baseURL =
  typeof MOCK_SERVER_BASE_URL !== "undefined"
    ? MOCK_SERVER_BASE_URL
    : undefined;
